// Глобальный state попапов. Хранит как тип активного (открытого) попапа,
// так и данные, необходимые для рендеринга попапов.
// Предоставляет методы для обновления state для использования в компонентах

const {
    reactive,
    ref,
    readonly,
} = window.Vue;

// хранит id активного (открытого) попапа
const openedPopupIdState = {
    value: ref(null),
    updateValue(newPopupId) { this.value.value = newPopupId; },
};

// хранит данные, необходимые для рендеринга попапов
const popupsDataState = {
    error_popup: {
        data: ref([]),
        updateData({ errors }) { this.data.value = errors; },
    },
    message_popup: {
        data: reactive({
            message: "",
            messageDetails: [],
            onClose: null,
        }),
        updateData({
            message, messageDetails, onClose,
        }) {
            this.data.message = message;
            this.data.messageDetails = messageDetails;
            this.data.onClose = onClose;
        },
    },
    signup_payment_popup: {
        data: reactive({
            amount: 0,
            planName: "",
            quantity: 0,
        }),
        updateData({
            amount, planName, quantity,
        }) {
            this.data.amount = amount;
            this.data.planName = planName;
            this.data.quantity = quantity;
        },
    },
    registration_popup: {
        data: reactive({ signupSource: "UNKNOWN" }),
        updateData({ signupSource } = {}) { this.data.signupSource = signupSource || "UNKNOWN"; },
    },
};

// защита от попытки открыть открыть попап с несуществующим id
// или открыть попап, который требует данных, без этих данных
function isPopupDataCorrect(popupId, popupData) {
    // id попапов, которым для отображения нужны данные, передаваемые из компонента
    const popupIdsWithState = [
        "message_popup",
        "error_popup",
        "signup_payment_popup",
    ];
    // если запрашивается открытие попапа, который требует данные,
    // то нужно проверить, переданы ли эти данные
    if (popupIdsWithState.includes(popupId)) {
        return Boolean(popupData) && Boolean(Object.keys(popupData).length);
    }
    // все существующие id попапов
    const allPopupIds = [...popupIdsWithState,
                         "password_reset_popup",
                         "registration_popup",
                         "authorization_popup"];
    return allPopupIds.includes(popupId);
}

function _dispatchOpen({
    newPopupId, popupData,
}) {
    // если переданы некорректные данные,
    // то в качестве активного (открытого) попапа ставим null
    if (!isPopupDataCorrect(newPopupId, popupData)) {
        openedPopupIdState.updateValue(null);
        return;
    }
    // если для попапа, который хотим открыть, есть данные в state - обновить их на переданные
    popupsDataState[newPopupId]?.updateData(popupData);
    // установить новый id активного (открытого) попапа
    openedPopupIdState.updateValue(newPopupId);
}

// устанавливает openedPopupId в null
function _dispatchClose() {
    if (openedPopupIdState.value) {
        openedPopupIdState.updateValue(null);
    }
}

// обеспечивает единое состояние при импортах в разных файлах
// убрать, когда появится единый корневой компонент Vue
window.addEventListener("popupClosed", _dispatchClose);

window.addEventListener(
    "popupDataChanged",
    e => _dispatchOpen({
        newPopupId: e.detail.newPopupId,
        popupData: e.detail.popupData,
    }),
);

// для использования в компонентах экспортируются только данные попапов
// и общие методы обновления state
export default {
    errorPopupData: readonly(popupsDataState.error_popup.data),
    messagePopupData: readonly(popupsDataState.message_popup.data),
    signupPaymentPopupData: readonly(popupsDataState.signup_payment_popup.data),
    openedPopupId: readonly(openedPopupIdState.value),
    registrationPopupData: readonly(popupsDataState.registration_popup.data),
    dispatchOpen({
        newPopupId, popupData,
    }) {
        _dispatchOpen({
            newPopupId,
            popupData,
        });
        window.dispatchEvent(new CustomEvent("popupDataChanged", {
            detail: {
                newPopupId,
                popupData,
            },
        }));
    },
    dispatchClose() {
        _dispatchClose();
        window.dispatchEvent(new CustomEvent("popupClosed"));
    },
};
